// Compact draggable card. Tuned for the 380 px right-pane width: a
// 56 px thumbnail, two-line title clamp, and a metadata strip below.
// `cursor: grab` while idle, `cursor: grabbing` while dragging
// (native HTML5 DnD doesn't toggle the cursor for us).

.root {
  align-items: stretch;
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  color: inherit;
  cursor: grab;
  display: flex;
  font: inherit;
  gap: 10px;
  padding: 10px;
  text-align: left;
  // `pan-y`, not `none` (XT-591). `none` handed EVERY touch to dnd-kit, so a
  // finger starting on a card could not scroll the picker at all — the flick
  // became a drag and adding a product on release. The touch sensor now
  // activates on a 250ms hold instead of on movement, so the browser can keep
  // vertical panning; it still suppresses horizontal panning and
  // double-tap-zoom, which would otherwise fight a held drag.
  touch-action: pan-y;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
  user-select: none;
  width: 100%;

  &:hover {
    border-color: var(--color-primary);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  &:focus-visible {
    border-color: var(--color-primary);
    box-shadow: 0 0 0 2px var(--color-primary);
    outline: none;
  }
}

.root-is-dragging {
  cursor: grabbing;
  opacity: 0.4;
}

.thumb {
  align-items: center;
  background: var(--color-secondary);
  border-radius: 6px;
  display: flex;
  flex: 0 0 56px;
  height: 56px;
  justify-content: center;
  overflow: hidden;
}

.thumb-img {
  display: block;
  height: 100%;
  object-fit: cover;
  width: 100%;
}

.thumb-placeholder {
  color: var(--color-muted-foreground);
}

.body {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.title-row {
  align-items: flex-start;
  display: flex;
  gap: 6px;
  min-width: 0;
}

.category-icon {
  color: var(--color-muted-foreground);
  flex: 0 0 auto;
  margin-top: 2px;
}

.title {
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  min-width: 0;
  overflow: hidden;
  word-break: break-word;
}

.meta-row {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 4px 10px;
}

.meta-item {
  align-items: center;
  color: var(--color-muted-foreground);
  display: inline-flex;
  font-size: 12px;
  gap: 4px;
}
